import clsx from "clsx";
import { useEffect, useState } from "react";
import { keycloak } from "../../lib/keycloak";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { colors } from "../../ui/colors";
import { PlusIcon } from "../../ui/icons/plus";
import Button from "../../ui/molecules/button";
import Input from "../../ui/molecules/input/Input";
import { Spinner } from "../../ui/molecules/spinner";
import {
  editParticularityName,
  findAllParticularities,
  setEditParticularityNameStatus,
  setSelectedParticularity
} from "./slice";

export function EditParticularity() {
  const particularitiesState = useAppSelector((state) => state.particularities);

  const dispatch = useAppDispatch();

  const [errorName, setErrorName] = useState<boolean>(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (
      particularitiesState.editParticularityNameStatus === "failed" ||
      particularitiesState.editParticularityNameStatus === "successfully"
    ) {
      dispatch(setSelectedParticularity(undefined));
      if (particularitiesState.editParticularityNameStatus === "successfully") {
        dispatch(
          findAllParticularities({
            itemsPerPage: particularitiesState.filters.itemsPerPage,
            order: true,
            page: 0,
            sort: "name",
            name: ''
          })
        );
      }
      timeoutId = setTimeout(() => {
        dispatch(setEditParticularityNameStatus("idle"));
      }, 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [particularitiesState.editParticularityNameStatus]);

  return (
    <div
      onClick={() => dispatch(setSelectedParticularity(undefined))}
      className={clsx(
        "transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]",
        {
          block: particularitiesState.selectedParticularity,
          hidden: !particularitiesState.selectedParticularity,
        }
      )}
    >
      {particularitiesState.editParticularityNameStatus === "loading" ? (
        <Spinner />
      ) : (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className="transition-all relative flex flex-col items-center bg-white rounded-[12px] opacity-100 shadow-sm min-w-[400px]"
        >
          <div
            onClick={() => dispatch(setSelectedParticularity(undefined))}
            className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
          >
            <PlusIcon color={colors.brandPrimary[600]} size={16} />
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="p-6 text-heading-xs font-semibold text-center">
              Modifica particolarità
            </div>
          </div>
          <div className="px-6 py-8 w-full flex flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
            <div className="flex flex-col w-full h-full gap-3">
              <Input
                placeholder="Nome particolarità"
                error={errorName}
                value={particularitiesState.selectedParticularity?.name}
                onChangeText={(e) =>
                  dispatch(
                    setSelectedParticularity({
                      name: e,
                      id: particularitiesState.selectedParticularity?.id,
                    })
                  )
                }
                supportingText={
                  errorName ? "Inserisci il nome della particolarità" : undefined
                }
              />
            </div>
            <div className="w-full flex flex-1 gap-3">
              <div className="w-1/2">
                <Button
                  fullWidth
                  size={"sm"}
                  iconPosition={"off"}
                  variant={"outline"}
                  color={"gray"}
                  label="Annulla"
                  onClick={() => dispatch(setSelectedParticularity(undefined))}
                />
              </div>
              <div className="w-1/2">
                <Button
                  fullWidth
                  size={"sm"}
                  disabled={keycloak.hasRealmRole("commercial")}
                  iconPosition={"off"}
                  variant={"solid"}
                  color={"blue"}
                  label="Conferma"
                  onClick={() => {
                    if (
                      !particularitiesState.selectedParticularity?.name ||
                      particularitiesState.selectedParticularity?.name ===
                      undefined ||
                      particularitiesState.selectedParticularity?.name === ""
                    ) {
                      setErrorName(true);
                    } else {
                      dispatch(
                        editParticularityName({
                          data: {
                            name: particularitiesState.selectedParticularity
                              ?.name!,
                          },
                          id: particularitiesState.selectedParticularity?.id!,
                        })
                      );
                      dispatch(setSelectedParticularity(undefined))
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
